module.exports = __webpack_public_path__ + "static/img/industry-zf.913aea69.png";